import PsychologistsList from './PsychologistsList/PsychologistsList.vue'
export default {
  name: 'Psychologists',
  watch: {
    "$route.params"(value) {
      this.selectedTab = value.tab || 'todos'
    }
  },
  mounted() {

  },
  computed: {

    // entryFeeSelected() {
    //   console.log('wtf')
    //   return "wtf"
    // },

  },
  data() {
    return {
      dateFilter: '',
      customDateFrom: '',
      customDateTo: '',
      dateFilterOptions: [
        { id: '', title: 'Todas as datas' },
        { id: 'hoje', title: 'Hoje' },
        { id: 'ontem', title: 'Ontem' },
        { id: 'ultimos_30_dias', title: 'Últimos 30 dias' },
      ],
      onlyPremium: false,
      tabs: [
        {
          id: 'todos',
          name: 'Todos',
          totalCount: 0
        },
        {
          id: 'aprovados',
          name: 'Aprovados',
          totalCount: 0
        },
        {
          id: 'reprovados',
          name: 'Não aprovados',
          totalCount: 0
        },
        {
          id: 'online',
          name: 'Agenda online',
          totalCount: 0
        },
      ],
      totalPsiCount: 0,
      selectedTab: this.$route.params.tab || 'todos',
    };
  },
  methods: {
    totalChanged(event, key) {
      let t = [...this.tabs]
      t.map(r => {
        if (r.id === key) {
          r.totalCount = event.total
        }
      })
      this.$set(this, 'tabs', t)
      if (!this.onlyPremium && key == 'todos') {
        this.totalPsiCount = event.total
      }
    },
    handlePremiumFilterChanged() {
      this.$eventBus.$emit("updatePsiList", { onlyPremium: this.onlyPremium });
    },
    dateFilterChanged(value) {
      let date_from = null;
      let date_to = null;
      const today = this.$moment().format('YYYY-MM-DD');
      const yesterday = this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
      const last30 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD');

      if (value === 'hoje') {
        date_from = today;
        date_to = today;
      } else if (value === 'ontem') {
        date_from = yesterday;
        date_to = yesterday;
      } else if (value === 'ultimos_30_dias') {
        date_from = last30;
        date_to = today;
      }

      // Atualiza os campos de data customizados
      this.customDateFrom = date_from || '';
      this.customDateTo = date_to || '';

      this.$eventBus.$emit("updatePsiList", {
        onlyPremium: this.onlyPremium,
        date_from,
        date_to
      });
    },
    customDateChanged() {
      // Limpa o select quando usar datas customizadas
      this.dateFilter = '';

      this.$eventBus.$emit("updatePsiList", {
        onlyPremium: this.onlyPremium,
        date_from: this.customDateFrom || null,
        date_to: this.customDateTo || null
      });
    }
  },

  components: {
    PsychologistsList
  },
  validations: {
    dateFilter: ''
  }
};
